export default __webpack_public_path__ + "8dad6689fe5d8aff10ec60c8780f0e84.svg";